<template>
  <div id="app">
    <v-app id="inspire">

      <body>
        <p align="center">
          <b>
            <font face="Arial">Informes de la Dirección</font>
          </b>
        </p>
        <table border="1" cellspacing="1" width="100%" id="AutoNumber1">
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0010.pdf">Informe Nº:
                  10</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0011.pdf">Informe Nº:
                  11</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0012.pdf">Informe Nº:
                  12</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0013.pdf">Informe Nº:
                  13</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0014.pdf">Informe Nº:
                  14</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0015.pdf">Informe Nº:
                  15</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0016.pdf">Informe Nº:
                  16</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0017.pdf">Informe Nº:
                  17</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0018.pdf">Informe Nº:
                  18</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0019.pdf">Informe Nº:
                  19</a>
              </font>
            </td>
          </tr>

          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0020.pdf">Informe Nº:
                  20</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0021.pdf">Informe Nº:
                  21</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0022.pdf">Informe Nº:
                  22</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0023.pdf">Informe Nº:
                  23</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0024.pdf">Informe Nº:
                  24</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0025.pdf">Informe Nº:
                  25</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0026.pdf">Informe Nº:
                  26</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0027.pdf">Informe Nº:
                  27</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0028.pdf">Informe Nº:
                  28</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0029.pdf">Informe Nº:
                  29</a>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                <a target="_blank" href="https://api.icssa.com.ar/Direccion/InfDireccion/EI%20010-0030.pdf">Informe Nº:
                  30</a>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                Informe N°: 31 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI010-0031')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
          </tr>
          <tr>
            <td width="50%" align="center">
              <font face="Arial">
                Informe N°: 32 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI010-0032')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
            <td width="50%" align="center">
              <font face="Arial">
                Informe N°: 33 <v-icon small color="blue" class="mr-2" @click.stop="verDoc('EI010-0033')">
                  mdi-eye
                </v-icon>
              </font>
            </td>
          </tr>
        </table>
      </body>

      <VerDoc :visible="showDoc" :doc="this.doc" @close="showDoc = false">
      </VerDoc>
    </v-app>
  </div>
</template>


<script>
import VerDoc from "../Direccion/Visualizardoc.vue";
export default {
  components: { VerDoc },
  data: (vm) => ({
    doc: "",
    showDoc: false,
  }),
  computed: {
    show: {
      get() {

        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {

    verDoc(item) {
      this.doc = item;
      this.showDoc = true;
    },
  },
};
</script>